(function () {
  'use strict';

  function pinQuickAddToBottom() {
    document.querySelectorAll('.card-quick-add').forEach(function (el) {
      var p = el.parentElement;
      if (!p) return;
      if (window.getComputedStyle(p).position === 'static') {
        p.style.position = 'relative';
      }
      var h = el.offsetHeight;
      if (h === 0) return;
      p.style.paddingBottom = (h + 8) + 'px';
      el.style.position = 'absolute';
      el.style.bottom = '0';
      el.style.left = '0';
      el.style.right = '0';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinQuickAddToBottom);
  } else {
    pinQuickAddToBottom();
  }

  var SEL_BLOCK    = '.card-quick-add';
  var SEL_INPUT    = '.card-quick-add__qty-input';
  var SEL_MINUS    = '.card-quick-add__qty-btn--minus';
  var SEL_PLUS     = '.card-quick-add__qty-btn--plus';
  var SEL_VARIANT  = '.card-quick-add__variant-select';
  var SEL_BTN      = '.card-quick-add__cart-btn';
  var SEL_FEEDBACK = '.card-quick-add__feedback';

  function getBlock(el) { return el.closest(SEL_BLOCK); }
  function clamp(v, mn, mx) { return Math.min(Math.max(v, mn), mx); }

  function setButtonState(btn, state) {
    btn.setAttribute('data-state', state);
    var labels = { idle: 'In den Warenkorb', adding: 'Wird hinzugef\u00fcgt\u2026', added: 'Hinzugef\u00fcgt', error: 'Fehler' };
    btn.setAttribute('aria-label', labels[state] || labels.idle);
  }

  function showFeedback(block, msg, type) {
    var el = block.querySelector(SEL_FEEDBACK);
    if (!el) return;
    if (type === 'success') {
      el.innerHTML = msg + ' &mdash; <a href="/cart">Warenkorb &rarr;</a>';
    } else {
      el.textContent = msg;
    }
    el.className = 'card-quick-add__feedback card-quick-add__feedback--' + type;
  }

  function clearFeedback(block) {
    var el = block.querySelector(SEL_FEEDBACK);
    if (!el) return;
    el.innerHTML = '';
    el.className = 'card-quick-add__feedback';
  }

  function getVariantId(block) {
    var select = block.querySelector(SEL_VARIANT);
    if (select && select.value) return select.value;
    return block.dataset.variantId;
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Unbekannter Fehler'); });
      return r.json();
    });
  }

  // Exakt dieselbe Logik wie FoxKitAddToCart im Theme
  function notifyCartUpdate(addedItems) {
    var sectionParam = window.FoxKitSections;

    var cartFetch = fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig())
      .then(function (r) { return r.json(); });

    var sectionFetch = sectionParam
      ? fetch('/?sections=' + sectionParam).then(function (r) { return r.json(); })
      : Promise.resolve({});

    Promise.all([cartFetch, sectionFetch])
      .then(function (res) {
        var cartJson = res[0];
        cartJson.sections = res[1];

        // FoxTheme pubsub → aktualisiert Cart-Drawer Inhalt
        FoxTheme.pubsub.publish(
          FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          { cart: cartJson }
        );

        // product-ajax:added → öffnet Cart-Drawer (identisch zum Theme-Button)
        document.dispatchEvent(new CustomEvent('product-ajax:added', {
          detail: { product: addedItems || cartJson },
          bubbles: true
        }));

        // Fallback: Count-Badge
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .header__cart-count, .cart-icon-bubble').forEach(function (el) {
          el.textContent = cartJson.item_count;
          if (cartJson.item_count > 0) el.removeAttribute('hidden');
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest(SEL_MINUS);
    if (minus) {
      var b = getBlock(minus), i = b && b.querySelector(SEL_INPUT);
      if (i) i.value = clamp(parseInt(i.value, 10) - 1, 1, 999);
      return;
    }
    var plus = e.target.closest(SEL_PLUS);
    if (plus) {
      var b = getBlock(plus), i = b && b.querySelector(SEL_INPUT);
      if (i) i.value = clamp(parseInt(i.value, 10) + 1, 1, 999);
      return;
    }
    // Accessories "In den Warenkorb"
var accBtn = e.target.closest('.acc-btn[data-add]');
if (accBtn) {
  var accItem = accBtn.closest('.acc-item');
  if (!accItem || accBtn.disabled || accBtn.dataset.state === 'adding') return;
  var variantId = accItem.dataset.variantId;
  if (!variantId) return;
  var origText = accBtn.textContent.trim();
  accBtn.dataset.state = 'adding';
  accBtn.disabled = true;
  accBtn.textContent = 'Wird hinzugef\u00fcgt\u2026';
  addToCart(variantId, 1)
    .then(function (added) {
      accBtn.textContent = 'Hinzugef\u00fcgt \u2713';
      accBtn.dataset.state = 'added';
      notifyCartUpdate(added);
      setTimeout(function () {
        accBtn.textContent = origText;
        accBtn.dataset.state = '';
        accBtn.disabled = false;
      }, 2500);
    })
    .catch(function (err) {
      accBtn.textContent = err.message || 'Fehler';
      accBtn.dataset.state = 'error';
      setTimeout(function () {
        accBtn.textContent = origText;
        accBtn.dataset.state = '';
        accBtn.disabled = false;
      }, 3000);
    });
  return;
}
    var btn = e.target.closest(SEL_BTN);
    if (!btn) return;
    var block = getBlock(btn);
    if (!block || btn.getAttribute('data-state') === 'adding') return;
    var variantId = getVariantId(block);
    var input = block.querySelector(SEL_INPUT);
    var qty = parseInt(input ? input.value : '1', 10) || 1;
    if (!variantId) { showFeedback(block, 'Variante nicht gefunden', 'error'); return; }
    setButtonState(btn, 'adding');
    clearFeedback(block);
    addToCart(variantId, qty)
      .then(function (addedItems) {
        setButtonState(btn, 'added');
        showFeedback(block, qty + '\u00d7 hinzugef\u00fcgt', 'success');
        notifyCartUpdate(addedItems);
        setTimeout(function () { setButtonState(btn, 'idle'); clearFeedback(block); }, 3000);
      })
      .catch(function (err) {
        setButtonState(btn, 'error');
        showFeedback(block, err.message || 'Fehler beim Hinzuf\u00fcgen', 'error');
        setTimeout(function () { setButtonState(btn, 'idle'); clearFeedback(block); }, 3500);
      });
  });

  document.addEventListener('blur', function (e) {
    var input = e.target.closest(SEL_INPUT);
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) input.value = 1;
    else if (v > 999) input.value = 999;
  }, true);

  document.addEventListener('change', function (e) {
    var select = e.target.closest(SEL_VARIANT);
    if (!select) return;
    var block = getBlock(select);
    if (block) block.dataset.variantId = select.value;
  });

})();